import { render, staticRenderFns } from "./BillingIndex.vue?vue&type=template&id=2d5b58f6&"
import script from "./BillingIndex.vue?vue&type=script&lang=js&"
export * from "./BillingIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports